import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import type { Automation } from 'modules/automations/store/models/Automation'
import { Trigger } from 'modules/automations/store/models/Trigger'

export function automationTranslations(automation: Automation, name = '') {
  switch (automation.get('trigger')) {
    case Trigger.ContentKinds.monthly:
      return i18n.t('automations.automation.list.monthly_trigger', {
        day: automation.attributes.repeat_data,
      })
    case Trigger.ContentKinds.trimester:
      return i18n.t('automations.automation.list.trimester_trigger', {
        day: moment()
          .date(Number(automation.attributes.repeat_data?.split(' ')[0]))
          .format('D'),
        month: moment()
          .month(Number(automation.attributes.repeat_data?.split(' ')[1]) - 1)
          .format('MMMM'),
      })
    case Trigger.ContentKinds.weekly:
      return i18n.t('automations.automation.list.weekly_trigger', {
        day: moment().isoWeekday(Number(automation.attributes.repeat_data)).format('dddd'),
      })
    case Trigger.ContentKinds.yearly:
      return i18n.t('automations.automation.list.yearly_trigger', {
        day: moment()
          .date(Number(automation.attributes.repeat_data?.split(' ')[0]))
          .format('D'),
        month: moment()
          .month(Number(automation.attributes.repeat_data?.split(' ')[1]) - 1)
          .format('MMMM'),
      })
    default:
      return name || automation?.trigger?.name || ''
  }
}
